import React from "react";

const PublicLayout = ({ children }) => {
  return (
    <div>
      <p>Public Layout</p>

      {children}
    </div>
  );
};

export default PublicLayout;
